export const styles = theme => ({
    container: {},


    productSection: {},
    sectionTitle: {
        backgroundColor: "#f5f5f5",
        "& h2": {
            fontSize: 20,
            padding: "16px 0",
            margin: 0,
            color: "rgba(0,0,0,0.87)",
        },
        "& img": {
            margin: "22px 11px 0 19px",
            width: 19,
            float: "left",
        }
    },
    sectionDescription: {
        fontSize: 16,
        padding: 16,
        "& a": {
            textDecoration: "none",
        }
    },
    filterMessage: {
        marginLeft: theme.spacing(5),
        padding: theme.spacing(3),
        width: 450
    }
});